import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Loader2, Lock, Mail } from "lucide-react";
import { login, setToken } from "../lib/api";
import { LOGO_URL } from "../lib/content";

const inputCls =
  "w-full bg-black/50 border border-gold/25 rounded-sm pl-11 pr-4 py-3 text-white placeholder-gray-500 focus:border-gold focus:outline-none focus:ring-1 focus:ring-gold/50 transition-colors";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await login(email.trim(), password);
      setToken(data.access_token);
      toast.success("Welcome back!");
      navigate("/admin");
    } catch (err) {
      const detail = err?.response?.data?.detail;
      toast.error(typeof detail === "string" ? detail : "Login failed. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0A0A0A] flex items-center justify-center px-6">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <a href="/"><img src={LOGO_URL} alt="Everett - Sam's Treescape" className="h-16 w-auto mx-auto" /></a>
          <h1 className="font-serif text-2xl text-white mt-6">Lead Dashboard Login</h1>
          <p className="text-sm text-gray-400 mt-2">Authorized access only.</p>
        </div>
        <form onSubmit={submit} data-testid="login-form" className="bg-[#111111] border border-gold/25 rounded-xl p-8 shadow-2xl space-y-5">
          <div className="relative">
            <Mail size={18} className="absolute left-4 top-1/2 -translate-y-1/2 text-gold" />
            <input data-testid="login-email" type="email" required className={inputCls} placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} />
          </div>
          <div className="relative">
            <Lock size={18} className="absolute left-4 top-1/2 -translate-y-1/2 text-gold" />
            <input data-testid="login-password" type="password" required className={inputCls} placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} />
          </div>
          <button
            type="submit"
            data-testid="login-submit"
            disabled={loading}
            className="w-full bg-gold text-black font-bold px-8 py-4 rounded-sm hover:bg-gold-light transition-colors uppercase tracking-widest text-sm flex items-center justify-center gap-2 disabled:opacity-60"
          >
            {loading ? <><Loader2 className="animate-spin" size={18} /> Signing in...</> : "Sign In"}
          </button>
        </form>
        <p className="text-center mt-6"><a href="/" className="text-gold text-sm hover:text-gold-light">← Back to website</a></p>
      </div>
    </div>
  );
}
